import { useTranslate } from "@tolgee/react";
import type { Metric } from "../hooks/use-portfolio-chart";
import {
	formatCompactNumber,
	formatSignedUsd,
	formatUsd,
} from "#/lib/formatters";
import { cn } from "#/lib/utils";

type Props = {
	volume: number;
	rightLabel: string;
	currentValue: number;
	currentColor: string;
	metric: Metric;
};

export function PortfolioChartHeader({
	volume,
	rightLabel,
	currentValue,
	currentColor,
	metric,
}: Props) {
	const { t } = useTranslate();
	return (
		<div className="mt-4 flex flex-wrap items-baseline justify-between gap-2">
			<div className="flex items-baseline gap-2">
				<span className="text-label2 text-muted-foreground">
					{t("portfolio.chart.volume")}
				</span>
				<span className="text-title2 text-foreground">
					${formatCompactNumber(volume)}
				</span>
			</div>
			<div className="flex items-baseline gap-2">
				<span className="text-label2 text-muted-foreground">{rightLabel}</span>
				<span className={cn("text-title2", currentColor)}>
					{metric === "pnl"
						? formatSignedUsd(currentValue)
						: formatUsd(currentValue)}
				</span>
			</div>
		</div>
	);
}
